import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'NZ MOE' },
    { value: 3, label: 'AU ACT' },
    { value: 4, label: 'AU NSW' },
    { value: 5, label: 'AU NT' },
    { value: 6, label: 'AU QLD' },
    { value: 7, label: 'AU SA' },
    { value: 10, label: 'AU TAS' },
    { value: 8, label: 'AU VIC' },
    { value: 9, label: 'AU WA' },
    { value: 2, label: 'Independent School' },
    { value: 11, label: 'HK' },
    { value: 12, label: 'MY' },
    { value: 14, label: 'UK' },
    { value: 13, label: 'USA' },
  ],
});
